var _excluded = ["children", "className", "error", "hint", "hintUsesValidationState", "label", "labelFor", "labelId", "onClickLabel", "required", "infoTooltip", "infoTooltipProps", "validationState", "hideHintOnError"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import AHint from "../AHint";
import AIcon from "../AIcon";
import ATriggerTooltip from "../ATriggerTooltip";
import { ATooltipPropTypes } from "../ATooltip";
import "./AFieldBase.scss";
var AFieldBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    error = _ref.error,
    hint = _ref.hint,
    _ref$hintUsesValidati = _ref.hintUsesValidationState,
    hintUsesValidationState = _ref$hintUsesValidati === void 0 ? true : _ref$hintUsesValidati,
    label = _ref.label,
    labelFor = _ref.labelFor,
    labelId = _ref.labelId,
    onClickLabel = _ref.onClickLabel,
    required = _ref.required,
    infoTooltip = _ref.infoTooltip,
    _ref$infoTooltipProps = _ref.infoTooltipProps,
    infoTooltipProps = _ref$infoTooltipProps === void 0 ? {} : _ref$infoTooltipProps,
    _ref$validationState = _ref.validationState,
    validationState = _ref$validationState === void 0 ? "default" : _ref$validationState,
    _ref$hideHintOnError = _ref.hideHintOnError,
    hideHintOnError = _ref$hideHintOnError === void 0 ? true : _ref$hideHintOnError,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-field-base";
  if (validationState !== "default") {
    className += " a-field-base--".concat(validationState);
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var hintElement;
  if (hint && error && !hideHintOnError) {
    hintElement = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AHint, {
      className: "a-field-base__hint"
    }, hint), /*#__PURE__*/React.createElement(AHint, {
      className: "a-field-base__hint",
      validationState: validationState
    }, error));
  } else if (error) {
    hintElement = /*#__PURE__*/React.createElement(AHint, {
      className: "a-field-base__hint",
      validationState: validationState
    }, error);
  } else if (hint) {
    hintElement = /*#__PURE__*/React.createElement(AHint, {
      className: "a-field-base__hint",
      validationState: hintUsesValidationState && validationState
    }, hint);
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: className
  }), label &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
  React.createElement("label", {
    id: labelId,
    htmlFor: labelFor,
    onClick: onClickLabel,
    className: "a-field-base__label"
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: "a-field-base__label--required"
  }, "*"), infoTooltip && /*#__PURE__*/React.createElement(ATriggerTooltip, _extends({
    id: "".concat(labelId, "-tooltip"),
    placement: "top",
    content: infoTooltip,
    pointer: true
  }, infoTooltipProps), /*#__PURE__*/React.createElement(AIcon, null, "information"))), children, hintElement);
});
var anchorRef = ATooltipPropTypes.anchorRef,
  infoTooltipProps = _objectWithoutProperties(ATooltipPropTypes, ["anchorRef"]);
AFieldBase.propTypes = {
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * Style the hint with the validation state. Default: true.
   */
  hintUsesValidationState: PropTypes.bool,
  /**
   * Sets the label content.
   */
  label: PropTypes.node,
  /**
   * The label's `for` attribute.
   */
  labelFor: PropTypes.string,
  /**
   * The label's `id` attribute.
   */
  labelId: PropTypes.string,
  /**
   * Adds required asterisk next to label
   */
  required: PropTypes.bool,
  /**
   * Adds an information tooltip next to the label
   */
  infoTooltip: PropTypes.string,
  /**
   * Overrides props of `ATooltip` used to display `infoTooltip`. See `ATooltip.propTypes`.
   */
  infoTooltipProps: PropTypes.shape(infoTooltipProps),
  /**
   * Handles the label's `click` event.
   */
  onClickLabel: PropTypes.func,
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"])
};
AFieldBase.displayName = "AFieldBase";
export default AFieldBase;